import React, {useState} from 'react';
import {ModalesCategoriaServicios} from './ModalesCategoriaServicios';

export const HeadCategoriasServicios = (props) => {
	const {
		Seleccion,
		cambioSeleccion,
		CategoriasPosibles,
		definirCategoriasServicios,
		filtroNombre,
		setFiltroNombre,
		definirServicios,
		ListaSuperCategorias,
		ListaNombreSuperCategorias,
	} = props;

	const [Categorias, setCategorias] = useState(false);
	const [Servicios, setServicios] = useState(false);

	const actionButtonAnadir = () => {
		Seleccion[1][0] === 'buttonNotificacionesActive' ? setServicios(true) : setCategorias(true);
	};

	return (
		<>
			<ModalesCategoriaServicios
				Categorias={Categorias}
				setCategorias={setCategorias}
				Servicios={Servicios}
				setServicios={setServicios}
				reDefinirCategorias={definirCategoriasServicios}
				definirServicios={definirServicios}
				CategoriasPosibles={CategoriasPosibles}
				ListaSuperCategorias={ListaSuperCategorias}
				ListaNombreSuperCategorias={ListaNombreSuperCategorias}
			/>
			<div className='headUserFeedback'>
				<div className='superiorHeadContentUsuarios'>
					<div>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='40'
							height='40'
							fill='currentColor'
							className='bi bi-grid'
							viewBox='0 0 16 16'
						>
							<path d='M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z' />
						</svg>
					</div>
					<div className='centrador titleHeadHistorialFacturas'>
						Categorias y Servicios
					</div>
				</div>
				<div className='separador' />
				<div className='filtrosUsuario'>
					{/* 
                <div className='inputFechaFacturas'>
                    <input
                        type="text"
                        placeholder={
                            (Seleccion[1][0] === "buttonNotificacionesActive")
                                ? "Nombre Servicio/Categoria"
                                : "Nombre Categoria"
                        }
                        value={filtroNombre}
                        onChange={(e) => setFiltroNombre(e.target.value)}
                    />
                </div>
                    **/}
					<div></div>
					<div className='centrador'>
						<div
							className='buttonAnadir'
							onClick={() => actionButtonAnadir()}
						>
							<div className='centrador'>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='16'
									height='16'
									fill='currentColor'
									class='bi bi-plus-circle-fill'
									viewBox='0 0 16 16'
								>
									<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z' />
								</svg>
							</div>
							<div>
								{' '}
								<b>
									{Seleccion[1][0] === 'buttonNotificacionesActive'
										? 'Añadir Servicio'
										: 'Añadir Categoria'}
								</b>
							</div>
						</div>
					</div>
				</div>
				<div className='separador' />
				<div className='menuUserFeedback BotonesSuperiorPresupuestos'>
					<div
						className={Seleccion[0][0]}
						onClick={() => cambioSeleccion(0)}
					>
						<div className='centrador'>{Seleccion[0][1]}</div>
					</div>
					<div
						className={Seleccion[1][0]}
						onClick={() => cambioSeleccion(1)}
					>
						<div className='centrador'>{Seleccion[1][1]}</div>
					</div>
				</div>
			</div>
		</>
	);
};
